import type React from 'react';
import type { ElementType } from 'react';
import { twMerge } from 'tailwind-merge';
import type * as TF from 'type-fest';

import Box from '#/ui/components/box';
import type { OverrideProps } from '#/ui/utils/types';

export interface CardContentOwnProps {
  children?: React.ReactNode;
  className?: string;
}

export type CardContentTypeMap<
  AdditionalProps = TF.EmptyObject,
  RootComponent extends React.ElementType = 'div',
> = {
  props: AdditionalProps & CardContentOwnProps;
  defaultComponent: RootComponent;
};

export type CardContentProps<
  RootComponent extends React.ElementType = CardContentTypeMap['defaultComponent'],
  AdditionalProps = TF.EmptyObject,
  // @ts-expect-error
> = OverrideProps<CardContentTypeMap<AdditionalProps, RootComponent>, RootComponent> & {
  component?: React.ElementType;
};

function CardContent<C extends ElementType = 'div'>(
  { component = 'div', children, className, ...props }: CardContentProps<C>,
  ref?: React.ForwardedRef<C>
) {
  return (
    <Box
      {...props}
      component={component}
      ref={ref}
      className={twMerge('gooey-card-content text-base-content p-4', className)}
    >
      {children}
    </Box>
  );
}
CardContent.displayName = 'CardContent';

export default CardContent;
